interface IHandler {
  callback: (name: string, value: string) => boolean;
  message: string;
  fieldName: string;
}

type validationMessageFunction = (field: string, value: string) => string;
type validationMessageCallback = string | validationMessageFunction;

export default class CustomValidation implements IDigitalIdentityHubModule {
  public name = "CustomValidation";
  static moduleName = "CustomValidation";

  private handlers: { [fieldName: string]: IHandler } = {};
  private form: HTMLFormElement;
  private submitButton: HTMLButtonElement;
  private activeForm = false;
  private screen: string;

  public init(): void { /* No functionality */ }

  public ready(): void {
    janrain.events.onCaptureRenderComplete.addHandler(result => {
      this.screen = result.screen;

      // find form
      Object.keys(this.handlers).forEach(fieldName => {
        const currentHandler = this.handlers[fieldName];
        const field = window.DigitalIdentityHub.utilities.getCaptureField(this.screen, fieldName);

        if (field) {
          field.addEventListener("blur", () => {
            this.customFieldValidation(this.screen, fieldName, currentHandler.callback, currentHandler.message);
          });
          this.form = field.closest("form");
        }
      });

      if (this.form) {
        this.activeForm = true;
        this.submitButton = this.form.querySelectorAll("input[type=submit]")[0] as HTMLButtonElement;

        if (this.submitButton) {
          this.submitButton.addEventListener("click", e => this.handleSubmit(e));
        }
      }

      if (this.screen === "traditionalRegistration") {
        const form = document.getElementById("capture_traditionalRegistration_registrationForm");
        form.addEventListener("submit", () => {
          const field = window.DigitalIdentityHub.utilities.getCaptureField(this.screen, "preregEmailAddress");
          field.focus();
          field.blur();
        });
      }
    });
  }

  public add(fieldName: string, callback: (name: string, value: string) => boolean, message: string) {
    this.handlers[fieldName] = {
      fieldName,
      callback,
      message
    };
  }

  private customFieldValidation(screen: string, field: string, validationFunction: (field: string, value: string) => boolean, message: validationMessageCallback) {
    const fieldElem = window.DigitalIdentityHub.utilities.getCaptureField(screen, field);
    if (fieldElem === null) {
      return true;
    }
    let parentElem = fieldElem.parentNode as HTMLElement;
    if (fieldElem.type === "checkbox" || fieldElem.type === "select-one") {
      // in case of checkbox & select drop down we have element inside a wrapper due to that customValidation error message are not getting assigned;
      // Example acceptTermsofUse, acceptPrivacyPolicy, brandedConsent etc.
      parentElem = fieldElem.parentNode.parentNode as HTMLElement;
    }

    const validationResult = validationFunction(field, fieldElem.value);

    if (validationResult) {
      window.DigitalIdentityHub.utilities.removeClass(parentElem, "capture_error");
      window.DigitalIdentityHub.utilities.addClass(parentElem, "capture_validated");
    } else {
      if (typeof message === "string") {
        parentElem.querySelector(".capture_tip_error").textContent = message;
      } else if (typeof message === "function") {
        parentElem.querySelector(".capture_tip_error").textContent = message(field, fieldElem.value);
      }

      window.DigitalIdentityHub.utilities.removeClass(parentElem, "capture_validated");
      window.DigitalIdentityHub.utilities.addClass(parentElem, "capture_error");
    }

    return validationResult;
  }

  private validateFields() {
    const validation = Object.keys(this.handlers).map(fieldName => {
      const currentHandler = this.handlers[fieldName];

      return this.customFieldValidation(this.screen, fieldName, currentHandler.callback, currentHandler.message);
    });

    return validation.filter(value => !value).length === 0;
  }

  private blurAllFields() {
    if (this.form) {
      this.form.querySelectorAll("input").forEach(input => {
        input.focus();
        input.blur();
      });
      this.form.querySelectorAll("select").forEach(input => {
        input.focus();
        input.blur();
      });
    }
  }

  private handleSubmit(e: Event): void {
    const isValid = this.validateFields();

    if (!isValid) {
      e.preventDefault();
      e.stopPropagation();

      this.blurAllFields();
    }
  }
}
